import json_data from './toasts';
import React  from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Message } from './message';
import {storeToasterCookie} from "./cookieHelper";


const toastTemplate = json_data.filter(toast => checkDate(toast) && toast.toastMessage && toast.toastMessage.title && toast.toastMessage.body).map(toast => {
    return {
        id: toast.id,
        template: (
            <div className="toast-message">
                <h4>{toast.toastMessage.title}</h4>
                <Message message={toast.toastMessage.body}/>
            </div>
        )
    }
});

function checkDate(toast) {
    const currentDate = new Date().setHours(0,0,0,0);
    return currentDate >= toast.startDate && currentDate <= toast.endDate;
}

function showToast(notificationIds) {
    toastTemplate.filter(t => !notificationIds.includes(t.id) && t.template !== undefined).map(t => toast.info(t.template,
        {
            autoClose: 15000,
            position: "top-center",
            hideProgressBar: true,
            newestOnTop: true,
            pauseOnVisibilityChange:true,
            draggable:true,
            pauseOnHover:true,
            enableMultiContainer: true,
            delay: 1500,
            closeOnClick: false,
            onClose: () => storeToasterCookie(t.id)
        }));
}

function shouldShowNotification(lastSeenNotificationIds){
    return toastTemplate.filter(toast => lastSeenNotificationIds.includes(toast.id)).map(toast => toast.id);
}

export { showToast, shouldShowNotification };
